<template>
  <List class="px-3" finished-text="没有更多了">
    <div
      v-for="(item, index) in activityList"
      :key="index"
      class="flex flex-col mb-3 lightshadow rounded-lg py-2 pl-2"
    >
      <div class="flex flex-row flex-no-wrap overflow-x-auto">
        <div
          v-for="good in item.actGoodsList"
          :key="good.partGoodsId"
          class="flex flex-col mr-3"
        >
          <div
            style="height: 90px; width: 90px"
            class="rounded-md overflow-hidden"
          >
            <img
              src="https://img01.yzcdn.cn/vant/cat.jpeg"
              class="h-full w-full"
              alt=""
            />
          </div>
          <div class="flex flex-row justify-between items-center">
            <div>
              <span class="text-xs">¥</span
              ><span class="text-base font-semibold">{{ good.actPrice }}</span>
            </div>
            <span class="text-red"
              ><span class="text-xxs">省赚¥</span
              ><span class="text-xs">{{ good.saveProfit }}</span></span
            >
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-between mr-2 text-xs">
        <span><span>标签</span><span>双十一购物狂欢节</span></span
        ><Button
          style="padding-left: 6px; padding-right: 6px"
          round
          color="#E82035"
          size="mini"
          >分享赚钱
          <img
            class="inline-block h-3"
            src="@/assets/brandplace/forward.svg"
            alt=""
        /></Button>
      </div>
      <div class="flex flex-row justify-between flex-no-wrap items-center mr-2">
        <div class="flex flex-row flex-no-wrap overflow-x-scroll h-5">
          <span
            class="text-xxs text-red border-red1px rounded px-1 mr-1"
            style="white-space: nowrap; line-height: 1.125rem"
            >共110款</span
          ><span
            class="text-xxs text-red border-red1px rounded px-1 mr-1"
            style="white-space: nowrap; line-height: 1.125rem"
            >运费险</span
          ><span
            class="text-xxs text-red border-red1px rounded px-1 mr-1"
            style="white-space: nowrap; line-height: 1.125rem"
            >七天无理由退换</span
          ><span
            class="text-xxs text-red border-red1px rounded px-1 mr-1"
            style="white-space: nowrap; line-height: 1.125rem"
            >正品保障</span
          >
        </div>
        <div class="text-left flex-shrink-0 flex items-end">
          <Countdown :startTime="item.start" :endTime="item.end" />
        </div>
      </div>
    </div>
  </List>
</template>

<script>
import { Button, List } from "vant";
import Countdown from "@/components/activity/Countdown";
import { getActList } from "../webApi";
export default {
  components: { Button, Countdown, List },
  created() {
    getActList(this.$route.query.partId).then(({ data }) => {
      this.activityList = data;
    });
  },
  data() {
    return {
      loading: false,
      finished: false,
      activityList: [],
    };
  },
  methods: {},
};
</script>

<style>
</style>
